import styled from "styled-components";
import { color, typeStyle, units } from "@m/alchemy-theme";
export const StyledHTML = styled.div `
  && ${({ blockScope = "" }) => blockScope} {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p,
    blockquote,
    ul li,
    ol li {
      ${typeStyle("bodyS")};
      color: ${color("typeBody")};
      line-height: 1.6;

      a {
        ${typeStyle("link")};
      }

      strong {
        font-weight: bold;
      }

      em {
        font-style: italic;
      }
    }

    h1 {
      ${typeStyle("headerXL")};
    }

    h2 {
      ${typeStyle("headerL")};
    }

    h3 {
      ${typeStyle("headerM")};
    }

    h4 {
      ${typeStyle("headerS")};
    }

    h5 {
      ${typeStyle("subHeaderM")};
    }

    h6 {
      ${typeStyle("subHeaderS")};
    }

    p {
      ${typeStyle("bodyS", { marginStrategy: "adjacent" })};
      margin: ${units(2.5)} 0;

      &:first-child {
        margin-top: 0;
      }
    }

    ul {
      list-style-type: disc;
      padding-left: ${units(2)};
    }
    ol {
      list-style-type: decimal;
      padding-left: ${units(2)};
    }

    ul,
    ol {
      margin-bottom: ${units(2)};
      margin-top: ${units(2)};
      margin-left: ${units(2)};

      p {
        margin: 0;
      }
      ul,
      ol {
        margin-bottom: 0;
        margin-top: 0;
        margin-left: 0;
      }
    }

    ol {
      > li::marker {
        font-weight: bold;
      }
      list-style-type: decimal;
      ol {
        list-style-type: lower-alpha;

        ol {
          list-style-type: decimal;
        }
      }
    }

    ul {
      list-style-type: disc;

      ul {
        list-style-type: circle;

        ul {
          list-style-type: square;
        }
      }
    }

    blockquote {
      padding-left: ${units(4)};
      display: block;
      border-left: 4px solid ${color("line")};
    }

    iframe,
    img {
      max-width: 100%;
    }
    table {
      margin: ${units(2.5)} 0;

      th,
      td {
        padding: 4px;
        border: 1px solid ${color("line")};
        line-height: 1.2;
        p {
          margin: 0;
          line-height: inherit;
        }
        p + p {
          margin-top: ${units(1)};
        }
      }
      th {
        font-weight: bold;
      }
    }
  }

  &::after {
    content: "";
    clear: both;
    display: table;
  }
`;
